import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import "src/assets/css/reset.css";
import "src/assets/css/global.css";
import { initializeGA } from "src/utils/analytics";
import DashboardPage from "src/pages/DashboardPage";
import InvitePage from "src/pages/InvitePage";
import ApplicationsPage from "src/pages/ApplicationsPage";
import ApplicationDetailPage from "src/pages/ApplicationDetailPage";
import EmployeesPage from "src/pages/EmployeesPage";
import { AppInitializer } from "src/initializers";
import { AppProviders } from "src/context";
import LoginPage from "./pages/LoginPage";
import LoginConfirmationPage from "./pages/LoginConfirmationPage";
import ProtectedLayout from "./layouts/ProtectedLayout";
import DealersPage from "./pages/DealersPage";
import ErrorPage from "./pages/ErrorPage";
import DealerSettings from "./pages/DealerSettings";

Sentry.init({
  dsn: __SENTRY_DSN__,
  environment: __ENV__,
  release: __SENTRY_RELEASE__,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});

const App = () => {
  useEffect(() => {
    initializeGA();
  }, []);
  return (
    <AppProviders>
      <Router
        future={{
          v7_startTransition: false,
          v7_relativeSplatPath: false,
        }}
      >
        <AppInitializer>
          <Routes>
            <Route path="/" element={<h2>Coming soon...</h2>} />
            <Route path={"login"}>
              <Route index element={<LoginPage />} />
              <Route
                path={"confirmation"}
                element={<LoginConfirmationPage />}
              />
            </Route>
            <Route path="error" element={<ErrorPage />} />
            <Route path="*" element={<Navigate to="/error" replace />} />
          </Routes>
        </AppInitializer>
      </Router>
    </AppProviders>
  );
};
const root = createRoot(document.getElementById("main")!);
root.render(<App />);
